// ═══════════════════════════════════════════════════════════════════════════════
// Subscription schemas (§22.9)
// ═══════════════════════════════════════════════════════════════════════════════
import { z } from 'zod';
import { SUBSCRIPTION_BILLING_INTERVAL } from '../utils/subscriptionPromotions.js';
const billingIntervalSchema = z.enum([
    SUBSCRIPTION_BILLING_INTERVAL.MONTH,
    SUBSCRIPTION_BILLING_INTERVAL.YEAR,
]);
export const subscriptionCheckoutBodySchema = z
    .object({
    billingInterval: billingIntervalSchema.default(SUBSCRIPTION_BILLING_INTERVAL.MONTH),
})
    .strict();
export const subscriptionIntervalChangeBodySchema = z
    .object({
    billingInterval: billingIntervalSchema,
})
    .strict();
//# sourceMappingURL=subscription.schema.js.map